var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5982 27.3322H8.27222V38.8162H32.5982V27.3322Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0902 4.7662H5.78023C5.45328 4.7662 5.18823 5.03125 5.18823 5.35821V11.4522C5.18823 11.7792 5.45328 12.0442 5.78023 12.0442H35.0902C35.4172 12.0442 35.6822 11.7792 35.6822 11.4522V5.35821C35.6822 5.03125 35.4172 4.7662 35.0902 4.7662Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4405 1.80219H11.4345C11.1031 1.80219 10.8345 2.07081 10.8345 2.40219V8.67019C10.8345 9.00156 11.1031 9.27019 11.4345 9.27019H29.4405C29.7718 9.27019 30.0405 9.00156 30.0405 8.67019V2.40219C30.0405 2.07081 29.7718 1.80219 29.4405 1.80219Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9982 8.87219H8.87222C8.54085 8.87219 8.27222 9.14082 8.27222 9.47219V38.2182C8.27222 38.5496 8.54085 38.8182 8.87222 38.8182H31.9982C32.3296 38.8182 32.5982 38.5496 32.5982 38.2182V9.47219C32.5982 9.14082 32.3296 8.87219 31.9982 8.87219Z",
    stroke: "#757575",
    strokeWidth: 3.49091,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.436279 0.818176H40.4363V40.8182H0.436279V0.818176Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrination);
export default __webpack_public_path__ + "static/media/Urination.2cbccfbe67b4d1a07cc2f4b5983e566b.svg";
export { ForwardRef as ReactComponent };